import { fetchCampaignProject, FetchCampaignProjectResponse } from 'api/queries';
import { useGraphql } from 'utils/hooks/useGraphql';

export function useCampaignProject() {
  const { data, isLoading } = useGraphql<FetchCampaignProjectResponse>(fetchCampaignProject);

  return { campaignProject: data?.currentProject, isLoading };
}
